<template>
  <div class="user-activity-view">
    <breadcrumb-button>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon icon="CheckSquareIcon" size="16"/>
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <div class="activity-panel">
      <div class="activity-panel__header">
        <div class="activity-panel__title">
          <div class="activity-panel__icon">
            <i class="fas fa-history"></i>
          </div>
          <div>
            <h4 class="activity-panel__heading">{{ $t('menu.userActivity') }}</h4>
            <div class="activity-panel__subtitle">
              {{ $t('Every administrative and user action, with who, what, and when.') }}
            </div>
          </div>
        </div>
      </div>
      <div class="activity-panel__body">
        <userActivity-table
            ref="userActivityTable"
            v-bind:filters="filter"
            v-bind:columns="columns"
            :has-selection="false"
            :lazy="true"
        />
      </div>
    </div>

    <columns-modal ref="columns-modal" column-key="userActivity" v-model="columns"
                   v-bind:columns-names="columnsNames"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BreadcrumbButton from '@/components/widget/breadcrumbButton';
import UserActivitySearchRequest from '@/model/tracker/TrackerSearchRequest';
import ColumnsModal from '@/components/modal/columnsModal';
import UserActivity from '@/model/tracker/Tracker';
import mixinPermissions from '@/components/mixin/mixinPermissions';
import mixinBase from '@/components/mixin/mixinBase';
import FilterCard from '@/components/widget/FilterCard';
import UserActivityFilterFields from '@/model/filter/UserActivityFilterFields';
import UserActivityTable from '@/components/tables/UserActivityTable';

export default {
  name: 'UserActivityView',
  components: {
    UserActivityTable,
    FilterCard,
    ColumnsModal,
    BreadcrumbButton,
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(UserActivity()),
      filter: UserActivitySearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    };
  },
  async created() {
    this.filterFields = UserActivityFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    openColumnsModal() {
      this.$refs['columns-modal'].showModal();
    },
  }
};
</script>

<style lang="scss" scoped>
.user-activity-view {
  .activity-panel {
    background: #ffffff;
    border: 1px solid rgba(0, 123, 255, 0.1);
    border-radius: 14px;
    box-shadow: 0 8px 24px -18px rgba(0, 123, 255, 0.4);
    overflow: hidden;

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      padding: 1rem 1.15rem;
      border-bottom: 1px solid rgba(0, 123, 255, 0.08);
      background: linear-gradient(135deg, rgba(0, 123, 255, 0.05), rgba(0, 123, 255, 0.01));
    }

    &__title {
      display: flex;
      align-items: center;
      gap: 0.8rem;
    }

    &__icon {
      width: 42px;
      height: 42px;
      border-radius: 12px;
      background: linear-gradient(135deg, #4da3ff 0%, #007BFF 60%, #0056b3 100%);
      color: #fff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 1.1rem;
      box-shadow: 0 8px 14px -8px rgba(0, 123, 255, 0.5);
    }

    &__heading {
      margin: 0;
      font-size: 1.05rem;
      font-weight: 700;
      color: #2f3b5b;
    }

    &__subtitle {
      font-size: 0.78rem;
      color: #6e7591;
      margin-top: 0.1rem;
    }

    &__body { padding: 0.25rem 0.5rem 0.5rem; }
  }
}

.dark-layout .user-activity-view {
  .activity-panel {
    background: #283046;
    border-color: rgba(77, 163, 255, 0.15);
    box-shadow: 0 8px 24px -18px rgba(0, 0, 0, 0.6);

    &__header {
      border-bottom-color: rgba(77, 163, 255, 0.12);
      background: linear-gradient(135deg, rgba(77, 163, 255, 0.1), rgba(77, 163, 255, 0.02));
    }

    &__heading { color: #d0d2d6; }
    &__subtitle { color: #9094a8; }
  }
}
</style>
